import { getToken } from './auth'

class WebSocketService {
  constructor() {
    this.socket = null
    this.reconnectAttempts = 0
    this.maxReconnectAttempts = 5
    this.reconnectDelay = 3000
    this.isConnected = false
    this.messageHandlers = []
    this.heartbeatInterval = null
    this.heartbeatTimeoutTimer = null
    this.heartbeatTimeout = 30000
    this.heartbeatIntervalTime = 30000
    this.lastHeartbeatTime = 0
    this.isClosing = false
  }

  // 初始化WebSocket连接
  initWebSocket(userInfo, permissions) {
    console.log(userInfo,'userInfo====')
    // 重置isClosing标志，确保新连接正常建立
    this.isClosing = false
    // 权限判断
    if (!this.hasWebSocketPermission(permissions)) {
      console.log('没有WebSocket访问权限')
      return false
    }

    if (this.socket) {
      this.socket.close()
      this.socket = null
    }

    const wsUrl = 'ws://192.168.1.70:6001'
    const projectId = userInfo.projectId || ''
    const userId = userInfo.id || ''
    
    try {
      this.socket = new WebSocket(
        `${wsUrl}/websocketglobal/web-abnormal-alarm-${projectId}-${userId}`
      )

      this.socket.onopen = (event) => {
        console.log('WebSocket连接已打开！')
        this.isConnected = true
        this.reconnectAttempts = 0
        this.startHeartbeat()
      }

      this.socket.onmessage = (event) => {
        console.log('收到WebSocket消息:', event.data)
        this.handleMessage(event.data)
      }

      this.socket.onclose = (event) => {
        console.log('WebSocket连接已关闭！', event)
        this.isConnected = false
        this.stopHeartbeat()
        // 只有非主动关闭时才重连
        if (!this.isClosing) {
          this.attemptReconnect(userInfo, permissions)
        } else {
          console.log('主动关闭WebSocket连接，不进行重连')
          // 重置isClosing标志
          this.isClosing = false
        }
      }

      this.socket.onerror = (error) => {
        console.error('WebSocket连接错误：', error)
        this.isConnected = false
      }
    } catch (error) {
      console.error('WebSocket初始化失败：', error)
      this.attemptReconnect(userInfo, permissions)
    }

    return true
  }

  // 检查是否有WebSocket访问权限
  hasWebSocketPermission(permissions) {
    console.log(permissions,'permissions===')
    // 这里根据实际的权限配置进行判断
    // 例如，检查用户是否有'realTimeMonitoring'权限
    return permissions && permissions.some(permission => 
      permission === 'baojingpeizhi_baojingpeizhi' 
    )
  }

  // 尝试重连
  attemptReconnect(userInfo, permissions) {
    if (this.reconnectAttempts < this.maxReconnectAttempts) {
      this.reconnectAttempts++
      console.log(`尝试重连WebSocket... (${this.reconnectAttempts}/${this.maxReconnectAttempts})`)
      console.log(`重连延迟: ${this.reconnectDelay * this.reconnectAttempts}ms`)
      
      setTimeout(() => {
        console.log(`执行WebSocket重连`)
        this.initWebSocket(userInfo, permissions)
      }, this.reconnectDelay * this.reconnectAttempts)
    } else {
      console.error('WebSocket重连失败，已达到最大重连次数')
      console.error('停止重连尝试')
    }
  }

  // 启动心跳
  startHeartbeat() {
    this.stopHeartbeat()
    this.lastHeartbeatTime = Date.now()
    
    this.heartbeatInterval = setInterval(() => {
      if (this.socket && this.isConnected) {
        try {
          this.socket.send(JSON.stringify({ type: 'heartbeat', timestamp: Date.now() }))
          this.resetHeartbeatTimeout()
        } catch (error) {
          console.error('发送心跳失败：', error)
        }
      }
    }, this.heartbeatIntervalTime)
  }
  
  // 重置心跳超时
  resetHeartbeatTimeout() {
    if (this.heartbeatTimeoutTimer) {
      clearTimeout(this.heartbeatTimeoutTimer)
    }
    
    this.heartbeatTimeoutTimer = setTimeout(() => {
      const now = Date.now()
      if (now - this.lastHeartbeatTime > this.heartbeatTimeout) {
        console.log('心跳超时，尝试重连')
        if (this.socket) {
          this.socket.close()
        }
        // 重连会在onclose中触发
      }
    }, this.heartbeatTimeout)
  }

  // 停止心跳
  stopHeartbeat() {
    if (this.heartbeatInterval) {
      clearInterval(this.heartbeatInterval)
      this.heartbeatInterval = null
    }
    if (this.heartbeatTimeoutTimer) {
      clearTimeout(this.heartbeatTimeoutTimer)
      this.heartbeatTimeoutTimer = null
    }
  }

  // 处理接收到的消息
  handleMessage(data) {
    try {
      const message = JSON.parse(data)
      
      // 处理心跳响应
      if (message.type === 'heartbeat_ack' || message.type === 'heartbeat ack') {
        this.lastHeartbeatTime = Date.now()
        return
      }
      
      // 触发所有消息处理器
      this.messageHandlers.forEach(handler => {
        if (typeof handler === 'function') {
          handler(message)
        }
      })
    } catch (error) {
      console.error('处理WebSocket消息失败：', error)
    }
  }

  // 注册消息处理器
  registerMessageHandler(handler) {
    if (typeof handler === 'function' && !this.messageHandlers.includes(handler)) {
      this.messageHandlers.push(handler)
    }
  }

  // 移除消息处理器
  removeMessageHandler(handler) {
    this.messageHandlers = this.messageHandlers.filter(h => h !== handler)
  }

  // 发送消息
  sendMessage(message) {
    if (this.socket && this.isConnected) {
      try {
        this.socket.send(typeof message === 'string' ? message : JSON.stringify(message))
        return true
      } catch (error) {
        console.error('发送WebSocket消息失败：', error)
        return false
      }
    }
    return false
  }

  // 关闭WebSocket连接
  closeWebSocket() {
    this.isClosing = true // 设置主动关闭标志
    this.stopHeartbeat()
    if (this.socket) {
      try {
        this.socket.close()
      } catch (error) {
        console.error('关闭WebSocket连接失败：', error)
      }
      this.socket = null
      this.isConnected = false
    }
  }

  // 检查连接状态
  getConnectionStatus() {
    return this.isConnected
  }
}

// 导出单例
const webSocketService = new WebSocketService()
export default webSocketService